import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Divider,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const statusColorMap = {
  approved: "#4caf50",
  pending: "#ff9800",
  rejected: "#f44336",
  active: "#22c55e",
  inactive: "#facc15",
  deleted: "#ef4444",
};

function formatIST(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

const fieldLabels = {
  fieldName: "Field Name",
  fieldType: "Field Type",
  placeholder: "Placeholder",
  flag: "Flag",
  section: "Section",
  status: "Status",
  createdAt: "Created On",
  updatedAt: "Updated On",
};

const ViewDataPopup = ({ open, onClose, data }) => {
  console.log(data, "===data");
  if (!data) return null;
  // Only show fields you want, and in order
  const fieldsToShow = {
    image: (
      <img
        style={{ width: "100px", height: "100px" }}
        src={data.image}
        alt="Images"
      />
    ),
    name: data.name,
    status: data.status,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 0,
          overflow: "visible",
          boxShadow: 8,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: 22,
          color: "#1e293b",
          pb: 1,
          pr: 5,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <InfoOutlinedIcon color="primary" sx={{ fontSize: 28, mr: 1 }} />
        Field Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "#64748b",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3, px: { xs: 1, sm: 3 } }}>
        <Table size="small" sx={{ minWidth: 320 }}>
          <TableBody>
            {Object.keys(fieldsToShow).map((key) => {
              if ((key === "createdAt" || key === "updatedAt") && !data[key])
                return null;
              if (
                key === "updatedAt" &&
                (!data.updatedAt || data.updatedAt === data.createdAt)
              )
                return null; // Hide if same as createdAt or not present

              let value = fieldsToShow[key];
              if (key === "status") {
                value = (
                  <Chip
                    label={String(fieldsToShow.status)}
                    sx={{
                      fontWeight: 600,
                      color: "#fff",
                      background:
                        statusColorMap[
                          String(fieldsToShow.status).toLowerCase()
                        ] || "#6366f1",
                      fontSize: 14,
                      px: 1.5,
                      textTransform: "capitalize",
                      letterSpacing: 0.5,
                    }}
                  />
                );
              } else if (key === "createdAt" || key === "updatedAt") {
                value = (
                  <Typography
                    sx={{
                      color: "#0f172a",
                      fontWeight: 500,
                      fontSize: 15,
                      letterSpacing: 0.1,
                    }}
                  >
                    {formatIST(fieldsToShow[key])}
                  </Typography>
                );
              } else {
                value = (
                  <Typography
                    sx={{
                      color: "#334155",
                      fontWeight: 500,
                      fontSize: 15,
                      letterSpacing: 0.1,
                    }}
                  >
                    {fieldsToShow[key] || "-"}
                  </Typography>
                );
              }
              return (
                <TableRow
                  key={key}
                  sx={{
                    "&:nth-of-type(odd)": {
                      background: "#f8fafc",
                    },
                    "&:nth-of-type(even)": {
                      background: "#fff",
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "#64748b",
                      border: "none",
                      fontSize: 15,
                      width: 120,
                      py: 1.2,
                    }}
                  >
                    {fieldLabels[key] || key}
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      py: 1.2,
                    }}
                  >
                    {value}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ borderRadius: 2, minWidth: 100 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewDataPopup;
